import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";
import { postOpenModal } from "../../../utils/utilPostMessage";

const CancelButton = ({ isSaving }) => {
  const dispatch = useDispatch();
  const { externalOverlay } = useSelector((state) => state.info);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const showCancelConfirmationModal = () => {
    if (externalOverlay) {
      const message = {
        childrenType: "confirmation",
        id: "cancel-changes",
        headerTitle: "Cancel Changes",
        bodyMessage: `Are you sure you want to cancel your changes?`,
        cancelText: "Keep",
        confirmText: "Cancel",
      };
      postOpenModal(message);
    } else {
      setIsConfirmationModalOpen(true);
    }
  };

  useEffect(() => {
    if (externalOverlay) {
      const handleMessage = (event) => {
        const data = event.data;

        if (data.type === "overlay-to-snippet") {
          const extra = data.extra;
          if (extra.id === "cancel-changes" && extra.action === "confirm") {
            onCancel();
          }
        }
      };

      // Add the event listener
      window.addEventListener("message", handleMessage);

      // Clean up the event listener on component unmount or when externalOverlay changes
      return () => {
        window.removeEventListener("message", handleMessage);
      };
    }
  }, [externalOverlay]);

  const onCancel = () => {
    dispatch({ type: "CANCEL" });
    toast.success("Changes have been canceled");
  };

  return (
    <>
      <button
        onClick={showCancelConfirmationModal}
        className={`action-button border border-gray-400 text-gray-400 hover:bg-gray-400 hover:text-white ${
          !isSaving ? "" : "disabled"
        }`}
      >
        Cancel
      </button>
      {!externalOverlay && isConfirmationModalOpen && (
        <ConfirmationModal
          onClose={() => setIsConfirmationModalOpen(false)}
          dataFromSnippet={{
            headerTitle: "Cancel Changes",
            bodyMessage: `Are you sure you want to cancel your changes?`,
            cancelText: "Keep",
            confirmText: "Cancel",
          }}
          onConfirm={onCancel}
          onCancel={() => setIsConfirmationModalOpen(false)}
        />
      )}
    </>
  );
};

export default CancelButton;
